

function CheckNull({ item }) {
    if (item === null || item === undefined || item === "") {
        return <p className="text-slate-400 mb-2">----</p>;
    }
    return <p className="mb-2">{String(item)}</p>;
}
export default CheckNull;